/**
 * AdminCatalogo
 * Página de administración del catálogo jerárquico maestro
 * Permite gestionar Áreas, Partidas y Recursos que serán referenciados en los presupuestos
 */

import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import CatalogoJerarquico from '../components/CatalogoJerarquico';
import authService from '../services/authService';
import { toast } from 'react-toastify';
import Loading from '../components/Loading';
import '../styles/admin-pages.css';

const AdminCatalogo = () => {
  const navigate = useNavigate();
  const [cuentaId, setCuentaId] = useState(null);
  const [loading, setLoading] = useState(true);

  // Get user cuenta on mount
  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const user = authService.getCurrentUser();
        if (!user) {
          navigate('/login');
          return;
        }

        // Get active cuenta from session or API
        const cuentaIdFromSession = sessionStorage.getItem('cuenta_id');
        if (cuentaIdFromSession) {
          setCuentaId(parseInt(cuentaIdFromSession));
        } else {
          // If no cuenta in session, redirect to main page
          toast.warning('Por favor selecciona una cuenta');
          navigate('/onebase');
        }
      } catch (error) {
        console.error('Error fetching user data:', error);
        toast.error('Error al cargar los datos del usuario');
        navigate('/login');
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, [navigate]);

  if (loading) {
    return <Loading />;
  }

  if (!cuentaId) {
    return (
      <div className="admin-catalog-container">
        <div className="error-message">
          <p>No se pudo determinar la cuenta</p>
        </div>
      </div>
    );
  }

  return (
    <div className="admin-catalog-container">
      <div className="admin-catalog-header">
        <h1>Catálogo Maestro</h1>
        <p className="subtitle">Gestiona la estructura jerárquica de Áreas, Partidas y Recursos que serán utilizados en los presupuestos</p>
      </div>

      <div className="admin-catalog-content">
        <CatalogoJerarquico cuentaId={cuentaId} />
      </div>
    </div>
  );
};

export default AdminCatalogo;
